import {AuthenticationProvider} from "@/modules/shared/bridges/AuthenticationProvider";
import {B2BAuthRepository} from "@/modules/b2bAuth/adapter/B2BAuthRepository";
import {B2BAuthPort} from "@/modules/b2bAuth/B2BAuthPort";
import {B2BAuthRestRepository} from "@/modules/b2bAuth/adapter/rest/B2BAuthRestRepository";


export class B2BAuthPortFactory {
    private readonly authenticationProvider: AuthenticationProvider;
    private b2bAuthRepository: B2BAuthRepository | null = null;

    private constructor(auth: AuthenticationProvider) {
        this.authenticationProvider = auth;
    }

    public static createB2BAuthPort(auth: AuthenticationProvider): B2BAuthPort {
        const factory = new B2BAuthPortFactory(auth);
        return new B2BAuthPort({
            b2BAuthRepository: factory.getB2bAuthRepository()
        });
    }

    private getB2bAuthRepository(): B2BAuthRepository {
        if (this.b2bAuthRepository === null) {
            this.b2bAuthRepository = new B2BAuthRestRepository(this.authenticationProvider);
        }
        return this.b2bAuthRepository;
    }
}
